/**
 * @license Copyright (c) 2003-2015, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or http://ckeditor.com/license
 */

CKEDITOR.plugins.addExternal('calltoaction', `${__webpack_public_path__}frontend/js/ckeditor/plugins/calltoaction/`);
CKEDITOR.plugins.addExternal('builderwidget', `${__webpack_public_path__}frontend/js/ckeditor/plugins/builderwidget/`);

module.exports = {
  embed_provider: '//iframely.rubinred.it/oembed?url={url}&callback={callback}',
  extraAllowedContent: '*[data-uk-*](uk-*,rr-*);div(*)[*]',
  disallowedContent: 'img{border*,margin*,width,height,float}',

  image_prefillDimensions: false,

  toolbar: [
    {name: 'templates', items: ['Undo', 'Redo']},
    {
      name: 'styles',
      items: ['Styles', 'Format', 'FontSize', 'RemoveFormat', '-', 'JustifyLeft', 'JustifyCenter', 'JustifyRight', 'JustifyBlock']
    },
    {name: 'basicstyles', items: ['Bold', 'Italic', 'Strike']},
    {name: 'clipboard', items: ['Cut', 'Copy', 'Paste', 'PasteFromWord', 'PasteText']},
    {name: 'paragraph', items: ['NumberedList', 'BulletedList', '-', 'Outdent', 'Indent', '-', 'Blockquote']},
    {name: 'links', items: ['Link', 'Unlink', 'Anchor']},
    {name: 'insert', items: ['Image', 'Calltoaction', 'CreateWidget', 'Embed', 'Table']},
    {name: 'tools', items: ['Maximize', 'ShowBlocks', '-', 'Source', 'Sourcedialog']}
  ],
  stylesSet: [
    {name: 'Text small', element: 'span', attributes: {'class': 'uk-text-small'}},
    {name: 'Text large', element: 'span', attributes: {'class': 'uk-text-large'}},
    {name: 'Text muted', element: 'span', attributes: {'class': 'uk-text-muted'}},
    {name: 'Text uppercase', element: 'span', attributes: {'class': 'uk-text-uppercase'}},
    {name: 'Text capitalize', element: 'span', attributes: {'class': 'uk-text-capitalize'}},
  ],
  font_names: "'Open Sans', Arial, Helvetica, sans-serif",
  fontSize_sizes: '14px;16px;18px;24px;30px;48px;',
  format_tags: 'p;h1;h2;h3;h4;h5;h6',
  uiColor: '#F3F3F3',
  extraPlugins: 'font,sourcedialog,sharedspace,calltoaction,builderwidget,embed,autoembed',
  removePlugins: 'maximize,resize',
  removeDialogTabs: 'image:advanced;link:advanced',
  magicline_everywhere: true,
  entities_additional: false,
  sharedSpaces: {
    top: 'ck-top-bar',
    bottom: 'ck-bottom-bar'
  },
  on: {
    dialogDefinition: function (ev) {
      var dialog = ev.data.definition.dialog;
      var scrollY, scrollX;
      dialog.on('show', function () {
        scrollY = window.scrollY;
        scrollX = window.scrollX;
      });
      dialog.on('hide', function () {
        setTimeout(function () {
          window.scrollTo(scrollX, scrollY);
        }, 10);
      });

      var dialogName = ev.data.name;
      var dialogDefinition = ev.data.definition;
      if (dialogName == 'image') {
        var infoTab = dialogDefinition.getContents('info');
        infoTab.get('htmlPreview').style += 'display:none';
      }
    }
  },
};



// WEBPACK FOOTER //
// ./public/themes/frontend/mtg/assets/js/ckeditor/config.js